import { render, staticRenderFns } from "./Tree4Bundles.vue?vue&type=template&id=db6ae424"
import script from "./Tree4Bundles.vue?vue&type=script&lang=js"
export * from "./Tree4Bundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports